import React, { useState, useEffect, useCallback, } from 'react';
import './documents.scss';
import { useNavigate } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import {getDocumentIds, deleteDocument} from '../../api/api'
import { useAuth } from '../../contexts/auth';
import List, { ItemDragging, MenuItem } from 'devextreme-react/list';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';

export default function Documents() {
  const { user, refreshSession } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);

  const addDocument = useCallback(() => {
    navigate('/templates')
  }, [navigate])

  const onDocumentClick = useCallback((item) => {
    navigate('/generate/edit/'+item.itemData.document_id)
  }, [navigate])

  const onDocumentDelete = useCallback((item) => {
    deleteDocument(user, {"document_id": item.itemData.document_id}, onDeleteSuccess, onError )
    setLoading(true)
  }, [navigate])

  const onDeleteSuccess = useCallback((data) => {
    getDocumentIds(user, onTemplateDataSuccess, onError)
  }, [])

  const onTemplateDataSuccess = useCallback((data) => {
    data = data.sort((a,b) => ((new Date(a.updated_at)) > (new Date(b.updated_at))) ? -1 : (((new Date(b.updated_at)) > (new Date(a.updated_at))) ? 1 : 0))
    setDocuments(data);
    setLoading(false);
  }, [])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      console.log(error);
    }
  }, [refreshSession]);

  useEffect(() => {
    if (user.signInUserSession) {
      getDocumentIds(user, onTemplateDataSuccess, onError)
    }
  }, [user, onTemplateDataSuccess, onError]);

  const onDragTemplatesStart = useCallback(
    (e) => {
      e.itemData = e.fromData === 'actualList'
        ? documents[e.fromIndex]
        : null;
    },
    [documents],
  );

  const onReorderTemplates = useCallback(
    (e) => {
      if (e.fromData === e.toData) {
        const updateTemplate = (q) => {
          const updatedQ = [...q];
          const [movedQ] = updatedQ.splice(e.fromIndex, 1);
          updatedQ.splice(e.toIndex, 0, movedQ);
          return updatedQ;
        };
        if (e.fromData === 'actualList') {
          setDocuments((prevTasks) => updateTemplate(prevTasks));
        }
      }
    },
    [],
  );

  return (
    <React.Fragment>
    {loading?
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
      :
      <>
      <div className="d-flex flex-row justify-content-between">
        <h2 className={''}>Documents</h2>
        <Button
            text="Add"
            icon="fas fa-plus"
            onClick={addDocument}
        />
      </div>
      <hr/>

      <div className="dx-card">

        <List
          dataSource={documents}
          height={400}
          itemDeleteMode={"static"}
          displayExpr={function(item) {
              // "item" can be null
              var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
              return item && item.document_name + ' (Last modified: ' + (new Date(item.updated_at)).toLocaleDateString("en-US", options) +')';
          }}
          onItemClick={onDocumentClick}
        >
          <ItemDragging
            allowReordering={true}
            group="tasks"
            data="actualList"
            onDragStart={onDragTemplatesStart}
            onReorder={onReorderTemplates}
          ></ItemDragging>
          <MenuItem
              text="Edit"
              action={onDocumentClick}
          />
          <MenuItem
              text="Delete"
              action={onDocumentDelete}
          />
        </List>
      </div>
      </>}
    </React.Fragment>
)}
